import {
	ComponentInternalInstance,
	getCurrentInstance as _getCurrentInstance
} from 'vue'

export function getCurrentInstance(name: string, message?: string) {
	const vm = _getCurrentInstance()

	if (!vm) {
		throw new Error(
			`${name} ${message || 'must be called from inside a setup function'}`
		)
	}

	return vm
}

let _uid = 0
let _map = new WeakMap<ComponentInternalInstance, number>()
export function getUid() {
	const vm = getCurrentInstance('getUid')

	if (_map.has(vm)) {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return _map.get(vm)!
	} else {
		const uid = _uid++
		_map.set(vm, uid)
		return uid
	}
}
getUid.reset = () => {
	_uid = 0
	_map = new WeakMap()
}
